export default "__VITE_ASSET__CUeB_WI2__"